"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackingData = void 0;
const ButtonRequestProps_1 = require("../../types/ButtonRequestProps");
const enums_1 = require("../../utils/enums");
const trackKeys_1 = require("./trackKeys");
const getEventData = (track, context) => {
    const { navigation, trackingId } = context;
    const commonData = {
        tracking_id: trackingId || enums_1.NOT_APPLY,
        social_app: 'google',
        source: navigation.source,
        contextual: navigation.contextual || enums_1.NOT_APPLY,
        select_by: navigation.select_by || enums_1.NOT_APPLY,
    };
    const event = {
        [trackKeys_1.TRACK_KEY.GOOGLE_AUTH_BUTTON_CLICK]: {
            ...commonData,
            selected_method: ButtonRequestProps_1.AuthCapabilities.GOOGLE_BUTTON,
        },
        [trackKeys_1.TRACK_KEY.GOOGLE_AUTH_ONE_TAP_CLICK]: {
            ...commonData,
            selected_method: ButtonRequestProps_1.AuthCapabilities.GOOGLE_ONE_TAP,
        },
    };
    return event[track];
};
const trackPath = {
    [trackKeys_1.TRACK_KEY.GOOGLE_AUTH_BUTTON_CLICK]: '/auth/social_account/google/complete',
    [trackKeys_1.TRACK_KEY.GOOGLE_AUTH_ONE_TAP_CLICK]: '/auth/social_account/google/complete',
};
const getTrackingData = (track, context) => {
    const { navigation } = context;
    const { business } = navigation;
    const trackingData = {
        path: trackPath[track],
        eventData: getEventData(track, context),
    };
    if (navigation.source === 'login') {
        trackingData.application = {
            business: business || enums_1.NOT_APPLY,
            site_id: navigation.site_id.toUpperCase() || enums_1.NOT_APPLY,
        };
    }
    return trackingData;
};
exports.getTrackingData = getTrackingData;
